/**
 * @file useDiscard.ts
 * @description «Отменить изменения» по частям вида сайта (phase19.16 Р1;
 * контракт §5): каждая выбранная часть возвращается к опубликованной
 * версии; нужно право правки каждой части (контент-менеджер отменяет своё
 * меню, не трогая оформление владельца).
 */

import { SITE_VIEW_PART_LABELS, type SiteViewPart } from "@chaiberi/shared";
import { useCallback, useState } from "react";

import { useSiteView } from "../../components/site-view/site-view-context";
import { useNotify } from "../../components/ui/NotifyProvider";
import { siteView } from "../../lib/api-site-view";
import { siteViewErrorText } from "../../lib/site-view/errors";

export interface DiscardApi {
  discard: (parts: SiteViewPart[]) => Promise<boolean>;
  busy: boolean;
}

export function useDiscard(): DiscardApi {
  const view = useSiteView();
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  const discard = useCallback(
    async (parts: SiteViewPart[]) => {
      if (parts.length === 0) return false;
      setBusy(true);
      try {
        view.replaceDraft(await siteView.discard(parts));
        const labels = parts.map((p) => SITE_VIEW_PART_LABELS[p]).join(", ");
        notify.success(`Изменения отменены: ${labels}. На сайте всё как было.`);
        return true;
      } catch (err) {
        notify.error(siteViewErrorText(err, "Не удалось отменить изменения. Черновик остался прежним."));
        return false;
      } finally {
        setBusy(false);
      }
    },
    [notify, view],
  );

  return { discard, busy };
}
